module.exports = __webpack_public_path__ + "img/testcricket.892edd9e.svg";